<div class="login-layout-container container">
  <div class="login-layout-container-box cw-login" [ngStyle]="layoutData?.boxStyles">
    <div [routerLink]="layoutData?.headerLink" [ngClass]="{ 'header-link': layoutData?.headerLink }">
      <div class="login-layout-container-box-image" *ngIf="layoutData?.image">
        <!-- Logo, title and instructions -->
        <img
          src="{{ layoutData.image }}"
          class="img-fluid"
          id="login-logo"
          alt="Asset Manager Logo"
          [ngStyle]="layoutData.imageStyles"
        />
      </div>
      <div class="login-layout-container-box-title" *ngIf="layoutData?.title">
        {{ layoutData.title }}
      </div>
      <div class="login-layout-container-box-instructions" *ngIf="layoutData?.instructions">
        {{ layoutData.instructions }}
      </div>
    </div>
    <!-- End Logo, title and instructions -->
    <!-- Form & buttons -->
    <div class="login-layout-container-box-body">
      <ng-content select="[box-body]"></ng-content>
    </div>
    <!-- End Form & buttons -->
  </div>
</div>
